const initFilters = () => {
   const filters = document.querySelectorAll('[data-filter]');
   const items = document.querySelectorAll('[data-filter-item]');
  
   let active = document.querySelector('.active[data-filter]');

   filters.length && items.length && filters.forEach(filter => {
      filter.addEventListener('click', () => {
         let direction = filter.getAttribute('data-direction');

         filter.classList.add('active');
         active?.classList.remove('active');
         active = filter;

         items.forEach((item) => {
            switch (direction) {
               case 'all':
                  item.style.display = null;
                  break;
               case item.getAttribute('data-direction'):
                  item.style.display = null;
                  item.style.opacity = '1';
                  break;
               default:
                  item.style.display = 'none';
                  break;
            };
         });
      })
   })
};
 
export default initFilters;
